import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { TEAM_NAME } from '@atlassian/jira-servicedesk-knowledge-common/src/common/constants.tsx';
import { fetchAiDraftPreviewContent as fetchAiDraftPreviewContentService } from '../../../../services/fetch-ai-draft-preview-content/index.tsx';
import type { State, Props } from '../../types.tsx';

export const fetchAiDraftPreviewContent =
	(topicId: string) =>
	async ({ getState, setState }: StoreActionApi<State>, props: Props): Promise<void> => {
		const { projectId, createAnalyticsEvent, activationId } = props;

		try {
			setState({
				...getState(),
				topics: {
					...getState().topics,
					data: getState().topics.data.map((topic) =>
						topic.topicId === topicId
							? {
									...topic,
									aiDraftPreview: {
										data: null,
										loading: true,
										error: null,
									},
								}
							: topic,
					),
				},
			});
			const response =
				(projectId &&
					(await fetchAiDraftPreviewContentService(projectId, activationId, topicId))) ||
				null;
			setState({
				...getState(),
				topics: {
					...getState().topics,
					data: getState().topics.data.map((topic) =>
						topic.topicId === topicId
							? {
									...topic,
									aiDraftPreview: {
										data: (response && response?.content) || null,
										loading: false,
										error: null,
									},
								}
							: topic,
					),
				},
			});

			fireTrackAnalytics(createAnalyticsEvent({}), 'fetchAiDraftPreviewContent succeeded', {
				projectId,
				topicId,
			});

			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'fetchAiDraftPreviewContent',
					packageName: 'jiraServicedeskKnowledgePerformance',
					teamName: TEAM_NAME,
				},
				error,
			});

			setState({
				...getState(),
				topics: {
					...getState().topics,
					data: getState().topics.data.map((topic) =>
						topic.topicId === topicId
							? {
									...topic,
									aiDraftPreview: {
										data: null,
										loading: false,
										error,
									},
								}
							: topic,
					),
				},
			});
		}
	};
